import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const GetUserModel = types
  .model("GetUserModel", {
    id: types.string,
    name: types.string,
    status: types.string,
    isAdmin: types.boolean,
    startDate: types.maybeNull(types.string),
    endDate: types.maybeNull(types.string),
    email: types.string
  })
  .actions((self) => ({
    fetch(email) {
      Framework.sendEvent("FETCHING_USER_DATA", {email});
    },
    set(response) {
      const data = response.data.response;
      applySnapshot(self, {
        id: data.id,
        name: data.name,
        status: data.status,
        isAdmin: data.isAdmin,
        startDate: data.startDate,
        endDate: data.endDate,
        email: data.email
      });
    },
  }));

export default GetUserModel;
